import { TaxCouponItemCofinsCst } from '@/core/domain/coupon/coupons/coupons.item.types';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

export const pisCofinsCstData = [
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_NORMAL_RATE,
    label:
      '01 - Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))',
  },
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_DIFFERENTIATED_RATE,
    label:
      '02 - Operação Tributável (base de cálculo = valor da operação (alíquota diferenciada))',
  },
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_QUANTITY_RATE,
    label:
      '03 - Operação Tributável (base de cálculo = quantidade vendida x alíquota por unidade de produto)',
  },
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_MONOPHASIC,
    label: '04 - Operação Tributável (tributação monofásica (alíquota zero))',
  },
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_SUBSTITUTION,
    label: '05 - Operação Tributável (Substituição Tributária)',
  },
  {
    value: TaxCouponItemCofinsCst.TAXABLE_OPERATION_ZERO_RATE,
    label: '06 - Operação Tributável (alíquota zero)',
  },

  {
    value: TaxCouponItemCofinsCst.EXEMPT_OPERATION,
    label: '07 - Operação Isenta da Contribuição',
  },
  {
    value: TaxCouponItemCofinsCst.NON_INCIDENCE_OPERATION,
    label: '08 - Operação Sem Incidência da Contribuição',
  },
  {
    value: TaxCouponItemCofinsCst.OPERATION_WITH_SUSPENSION,
    label: '09 - Operação com Suspensão da Contribuição',
  },
  {
    value: TaxCouponItemCofinsCst.OTHER_OUTPUT_OPERATIONS,
    label: '49 - Outras Operações de Saída',
  },
  {
    value: TaxCouponItemCofinsCst.OPERATION_WITH_INTERNAL_TAX_CREDIT,
    label:
      '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno',
  },
  {
    value:
      TaxCouponItemCofinsCst.OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT,
    label:
      '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno',
  },
  {
    value: TaxCouponItemCofinsCst.OPERATION_WITH_EXPORT_REVENUE_CREDIT,
    label:
      '52 - Operação com Direito a Crédito – Vinculada Exclusivamente a Receita de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT,
    label:
      '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno',
  },
  {
    value:
      TaxCouponItemCofinsCst.OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT,
    label:
      '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT,
    label:
      '55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT,
    label:
      '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação',
  },
  {
    value: TaxCouponItemCofinsCst.PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED,
    label:
      '60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno',
  },
  {
    value: TaxCouponItemCofinsCst.PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE,
    label:
      '61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno',
  },
  {
    value: TaxCouponItemCofinsCst.PRESUMED_CREDIT_EXPORT_REVENUE,
    label:
      '62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE,
    label:
      '63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno',
  },
  {
    value:
      TaxCouponItemCofinsCst.PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE,
    label:
      '64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE,
    label:
      '65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação',
  },
  {
    value:
      TaxCouponItemCofinsCst.PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE,
    label:
      '66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação',
  },
  {
    value: TaxCouponItemCofinsCst.OTHER_PRESUMED_CREDITS,
    label: '67 - Crédito Presumido - Outras Operações',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITHOUT_CREDIT,
    label: '70 - Operação de Aquisição sem Direito a Crédito',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITH_EXEMPTION,
    label: '71 - Operação de Aquisição com Isenção',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITH_SUSPENSION,
    label: '72 - Operação de Aquisição com Suspensão',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITH_ZERO_RATE,
    label: '73 - Operação de Aquisição a Alíquota Zero',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITHOUT_INCIDENCE,
    label: '74 - Operação de Aquisição; sem Incidência da Contribuição',
  },
  {
    value: TaxCouponItemCofinsCst.ACQUISITION_WITH_SUBSTITUTION,
    label: '75 - Operação de Aquisição por Substituição Tributária',
  },
  {
    value: TaxCouponItemCofinsCst.OTHER_INPUT_OPERATIONS,
    label: '98 - Outras Operações de Entrada',
  },
  {
    value: TaxCouponItemCofinsCst.OTHER_OPERATIONS,
    label: '99 - Outras Operações',
  },
];

const TaxeIcmsOriginSelect = forwardRef<BaseSelectRef, SelectProps>(
  (props, ref) => {
    return (
      <Select
        {...props}
        showSearch
        optionFilterProp="label"
        ref={ref}
        options={pisCofinsCstData}
      />
    );
  },
);

export default TaxeIcmsOriginSelect;
